import React from 'react';
import { useSelector } from 'react-redux';
import { Empty } from 'antd';
import Column from '../../shared/ui/Column';
import { selectors, actionCreators, sliceKeys } from '../../model';
import RelatedRoomsList from '../../controllers/RelatedRoomsList';
import ModelSearch from '../../controllers/ModelSearch';

const { selectSearch } = selectors[sliceKeys.relatedRooms];
const { selectHasRelations } = selectors[sliceKeys.houses];
const { searchChanged } = actionCreators[sliceKeys.relatedRooms];

const RelatedRoomsCol = () => {
  return (
    <Column title="Связанные помещения">
      <Content />
    </Column>
  );
};

export default RelatedRoomsCol;

function Content() {
  const hasRelations = useSelector(selectHasRelations);

  if (!hasRelations) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Нет настроенных связей"
      />
    );
  }

  return (
    <RelatedRoomsList>
      <ModelSearch selector={selectSearch} createAction={searchChanged} />
    </RelatedRoomsList>
  );
}
